import { render, staticRenderFns } from "./NodeGoalList.vue?vue&type=template&id=4186cf4a"
import script from "./NodeGoalList.vue?vue&type=script&lang=js"
export * from "./NodeGoalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports